(function () {
  'use strict';

  var API_BASE = 'https://admin.print-foundry.com/api/public/reviews';
  var summaryCache = {};

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function uniqueValues(value) {
    var seen = {};
    return String(value || '')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(function (item) {
        var key = item.toLowerCase();
        if (!item || seen[key]) return false;
        seen[key] = true;
        return true;
      });
  }

  function activeReviewTargets(root, handles, skus) {
    var scope = root.closest('.shopify-section') || document;
    var bundleRoot = scope.querySelector('[data-cf-bundle-product]');
    if (!bundleRoot) return { productHandles: handles, variantSkus: skus };
    var activeHandles = uniqueValues(bundleRoot.getAttribute('data-cf-active-review-handles'));
    var activeSkus = uniqueValues(bundleRoot.getAttribute('data-cf-active-review-skus'));
    if (!activeHandles.length && !activeSkus.length) {
      return { productHandles: handles, variantSkus: skus };
    }
    return { productHandles: activeHandles, variantSkus: activeSkus };
  }

  function reviewParams(handles, skus, extra) {
    var params = new URLSearchParams({ storeName: 'the-classic-fit' });
    if (handles.length) params.set('productHandles', handles.join(','));
    if (skus.length) params.set('variantSkus', skus.join(','));
    Object.keys(extra || {}).forEach(function (key) {
      params.set(key, extra[key]);
    });
    return params;
  }

  function summaryUrl(handles, skus) {
    return API_BASE + '/summary?' + reviewParams(handles, skus).toString();
  }

  function reviewsUrl(handles, skus) {
    return API_BASE + '?' + reviewParams(handles, skus, { limit: '100', includeStats: 'false' }).toString();
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Review request failed');
      return response.json();
    });
  }

  function starsMarkup(rating) {
    var filled = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var output = '';
    for (var index = 0; index < 5; index += 1) {
      output += index < filled ? '&#9733;' : '&#9734;';
    }
    return output;
  }

  function formatCount(value) {
    return (Number(value) || 0).toLocaleString('en-GB');
  }

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function publicCustomerName(value) {
    var name = String(value || '').trim().replace(/\s+/g, ' ');
    if (!name || /^verified\s+customer$/i.test(name)) return 'Verified customer';
    var parts = name.split(' ').filter(Boolean);
    var first = parts.shift() || '';
    var initials = parts.map(function (part) {
      var initial = part.replace(/[^a-z0-9]/gi, '').charAt(0).toUpperCase();
      return initial ? initial + '.' : '';
    }).filter(Boolean).join(' ');
    return [first, initials].filter(Boolean).join(' ');
  }

  function customerInitials(name) {
    if (/^verified\s+customer$/i.test(name)) return 'VC';
    return name.split(/\s+/).map(function (part) {
      return part.replace(/[^a-z0-9]/gi, '').charAt(0).toUpperCase();
    }).filter(Boolean).join('').slice(0, 2) || 'VC';
  }

  function fitProfile(review) {
    return review && review.fitProfile && typeof review.fitProfile === 'object' ? review.fitProfile : {};
  }

  function sizePurchased(review) {
    var fit = fitProfile(review);
    if (fit.sizePurchased) return fit.sizePurchased;
    var parts = String(review && review.variantTitle || '').split(/\s*[-/]\s*/).filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }

  function fitRowsMarkup(review) {
    var fit = fitProfile(review);
    var rows = [
      ['Weight Range', fit.weightRange],
      ['Usual Size', fit.usualSize],
      ['Size Purchased', sizePurchased(review)],
      ['Height', fit.heightRange]
    ].filter(function (row) { return row[1]; });
    if (!rows.length) return '';
    return '<dl class="cf-product-story__review-fit">' + rows.map(function (row) {
      return '<div class="cf-product-story__review-fit-row"><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
    }).join('') + '</dl>';
  }

  function photosMarkup(media) {
    var photos = (Array.isArray(media) ? media : []).filter(function (item) {
      return item && item.publicUrl;
    }).slice(0, 6);
    if (!photos.length) return '';
    return '<div class="cf-product-story__review-photos">' + photos.map(function (item) {
      return '<img src="' + escapeHtml(item.publicUrl) + '" alt="' + escapeHtml(item.filename || 'Customer review photo') + '" loading="lazy">';
    }).join('') + '</div>';
  }

  function reviewMarkup(review) {
    var name = publicCustomerName(review.customerDisplayName || review.customerName);
    var initials = review.customerInitials || customerInitials(name);
    var fit = fitProfile(review);
    var reply = review.merchantReply
      ? '<div class="cf-product-story__review-reply"><strong>The Classic Fit replied</strong><p>' + escapeHtml(review.merchantReply) + '</p></div>'
      : '';
    return '<article class="cf-product-story__review-item">' +
      '<div class="cf-product-story__review-meta">' +
        '<div class="cf-product-story__review-customer">' +
          '<div class="cf-product-story__review-avatar" aria-hidden="true">' + escapeHtml(initials) + '</div>' +
          '<div><strong class="cf-product-story__review-name">' + escapeHtml(name) + '</strong>' +
            (review.verified ? '<span class="cf-product-story__review-verified">Verified Buyer &#10003;</span>' : '') +
          '</div>' +
        '</div>' +
        (fit.recommendProduct === true ? '<div class="cf-product-story__review-recommend">&#10003; I recommend this product</div>' : '') +
        fitRowsMarkup(review) +
      '</div>' +
      '<div class="cf-product-story__review-copy">' +
        '<div class="cf-product-story__review-rating-row">' +
          '<span class="cf-product-story__review-item-stars" aria-label="' + escapeHtml(review.rating || 0) + ' out of 5 stars">' + starsMarkup(review.rating) + '</span>' +
          '<span class="cf-product-story__review-date">' + escapeHtml(formatDate(review.reviewedAt)) + '</span>' +
        '</div>' +
        '<h3>' + escapeHtml(review.title || 'Customer review') + '</h3>' +
        '<p>' + escapeHtml(review.body || '') + '</p>' +
        photosMarkup(review.media) + reply +
      '</div>' +
    '</article>';
  }

  function renderSummary(section, stats) {
    var summary = section.querySelector('[data-cf-review-summary]');
    if (!summary) return;
    var count = Number(stats && stats.count) || 0;
    var average = Number(stats && stats.average) || 0;
    var distribution = stats && stats.distribution && typeof stats.distribution === 'object'
      ? stats.distribution
      : {};
    summary.querySelector('[data-cf-review-average]').textContent = average.toFixed(1);
    summary.querySelector('[data-cf-review-stars]').innerHTML = starsMarkup(average);
    summary.querySelector('[data-cf-review-count]').textContent = 'Based on ' + formatCount(count) + ' review' + (count === 1 ? '' : 's');
    var bars = summary.querySelector('[data-cf-review-bars]');
    bars.innerHTML = [5, 4, 3, 2, 1].map(function (rating) {
      var ratingCount = Number(distribution[rating]) || 0;
      var width = count ? Math.min(100, (ratingCount / count) * 100) : 0;
      return '<div class="cf-product-story__review-bar-row">' +
        '<span>' + rating + ' &#9733;</span>' +
        '<span class="cf-product-story__review-bar-track"><span class="cf-product-story__review-bar-fill" style="width:' + width.toFixed(2) + '%"></span></span>' +
        '<span>' + formatCount(ratingCount) + '</span>' +
      '</div>';
    }).join('');
    summary.hidden = false;
  }

  function sortReviews(items, mode) {
    return items.slice().sort(function (left, right) {
      if (mode === 'highest') return (Number(right.rating) || 0) - (Number(left.rating) || 0);
      if (mode === 'lowest') return (Number(left.rating) || 0) - (Number(right.rating) || 0);
      return new Date(right.reviewedAt || 0).getTime() - new Date(left.reviewedAt || 0).getTime();
    });
  }

  function initialiseReviews(root, section, handles, skus) {
    var list = section.querySelector('[data-cf-review-list]');
    var status = section.querySelector('[data-cf-review-status]');
    var toolbar = section.querySelector('[data-cf-review-toolbar]');
    var sort = section.querySelector('[data-cf-review-sort]');
    var more = section.querySelector('[data-cf-review-more]');
    var pageSize = Math.max(3, Math.min(24, Number(section.getAttribute('data-page-size')) || 8));
    var visibleCount = pageSize;
    var reviews = [];

    function render() {
      var sorted = sortReviews(reviews, sort.value);
      list.innerHTML = sorted.slice(0, visibleCount).map(reviewMarkup).join('');
      more.hidden = visibleCount >= sorted.length;
    }

    sort.addEventListener('change', function () {
      visibleCount = pageSize;
      render();
    });
    more.addEventListener('click', function () {
      visibleCount += pageSize;
      render();
    });

    Promise.all([
      fetchJson(summaryUrl(handles, skus)),
      fetchJson(reviewsUrl(handles, skus))
    ]).then(function (responses) {
      var summaryPayload = responses[0] || {};
      var reviewsPayload = responses[1] || {};
      renderSummary(section, summaryPayload.stats || {});
      reviews = Array.isArray(reviewsPayload.items) ? reviewsPayload.items : [];
      status.hidden = true;
      if (!reviews.length) {
        status.textContent = 'No reviews yet.';
        status.hidden = false;
        return;
      }
      toolbar.hidden = false;
      render();
    }).catch(function () {
      status.textContent = 'Reviews are temporarily unavailable.';
    });
  }

  function fetchSummaryForHandle(handle) {
    var cleanHandle = String(handle || '').trim();
    if (!cleanHandle) return Promise.resolve(null);
    var key = cleanHandle.toLowerCase();
    if (!summaryCache[key]) {
      summaryCache[key] = fetchJson(summaryUrl([cleanHandle], []))
        .then(function (payload) { return payload.stats || null; })
        .catch(function () { return null; });
    }
    return summaryCache[key];
  }

  function initialiseCompareCards(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-cf-compare-card]'), function (card) {
      var handle = card.getAttribute('data-product-handle');
      var rating = card.querySelector('[data-cf-compare-rating]');
      if (!handle || !rating) return;
      fetchSummaryForHandle(handle).then(function (stats) {
        var count = Number(stats && stats.count) || 0;
        if (!count) return;
        var average = Number(stats.average) || 0;
        rating.innerHTML = '<span class="stars" aria-hidden="true">' + starsMarkup(average) + '</span> ' +
          escapeHtml(average.toFixed(1)) + ' (' + escapeHtml(formatCount(count)) + ')';
        rating.hidden = false;
      });
    });
  }

  function initialise(root) {
    if (!root || root.getAttribute('data-cf-story-ready') === 'true') return;
    root.setAttribute('data-cf-story-ready', 'true');
    var handles = uniqueValues(root.getAttribute('data-review-handles'));
    var skus = uniqueValues(root.getAttribute('data-review-skus'));
    var targets = activeReviewTargets(root, handles, skus);
    handles = targets.productHandles;
    skus = targets.variantSkus;
    var reviewsSection = root.querySelector('[data-cf-story-reviews]');
    var legacyRecommendations = document.querySelector('#shopify-section-product-recommendations, [id$="__product-recommendations"]');
    if (legacyRecommendations && root.querySelector('.cf-product-story__recommendation-card')) {
      legacyRecommendations.classList.add('cf-product-story-recommendations-replaced');
    }
    initialiseCompareCards(root);
    if (reviewsSection) initialiseReviews(root, reviewsSection, handles, skus);
  }

  function initialiseAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cf-product-story]'), initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
